<script setup lang="ts">
import DeleteButton from "@/components/DeleteButton.vue";
import type { Conversation } from "@/conversations/types";
import { EditPencil, Trash } from "@iconoir/vue";
import type { MutationStatus } from "@tanstack/vue-query";

const { canEdit, canDelete } = defineProps<{
  conversation: Conversation;
  canEdit: boolean;
  canDelete: boolean;
  deleteStatus: MutationStatus;
  hideContent?: boolean;
}>();

defineEmits<{
  edit: [];
  delete: [];
}>();
</script>

<template>
  <div v-if="!hideContent" class="card conversationContent">
    {{ conversation.content }}
  </div>
  <div v-if="canEdit || canDelete" class="row row-end">
    <button
      v-if="canEdit"
      class="button button--secondary"
      @click.prevent="$emit('edit')"
    >
      <EditPencil /><span class="visually-hidden">Bearbeiten</span>
    </button>
    <DeleteButton
      v-if="canDelete"
      class="button button--tertiary"
      :deleting-status="deleteStatus"
      @confirmed="$emit('delete')"
    >
      <Trash /><span class="visually-hidden">Löschen</span>
      <template #confirmation>
        Möchtest du dieses Gespräch wirklich löschen?
      </template>
    </DeleteButton>
  </div>
</template>

<style scoped>
.conversationContent {
  white-space: pre-wrap;
}
</style>
